module.exports = __webpack_public_path__ + "img/hr-rock-small-08.acb02107.png";